import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useI18n } from "../context/I18nContext";

export function FAQ({ items = [] }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(0);

  const list =
    items && items.length > 0
      ? items.map((f) => ({ q: f.question, a: f.answer }))
      : t.faq.items;

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div data-reveal className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#0d1b2a]/60">
              {t.faq.eyebrow}
            </div>
            <h2
              data-reveal
              className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0d1b2a] leading-[1.05]"
              style={{ fontFamily: "Chivo, Inter, sans-serif" }}
              data-testid="faq-heading"
            >
              {t.faq.heading}
            </h2>
          </div>

          <div className="lg:col-span-8">
            <div className="border-t border-[#0d1b2a]/10">
              {list.map((it, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={i}
                    className="border-b border-[#0d1b2a]/10"
                    data-testid={`faq-item-${i}`}
                  >
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                      data-testid={`faq-toggle-${i}`}
                    >
                      <span
                        className="text-base sm:text-lg font-bold text-[#0d1b2a] group-hover:text-[#ffb703] transition-colors"
                        style={{ fontFamily: "Chivo, Inter, sans-serif" }}
                      >
                        {it.q}
                      </span>
                      <span
                        className={`shrink-0 w-9 h-9 rounded-full border-2 flex items-center justify-center transition-all ${
                          isOpen
                            ? "bg-[#ffb703] border-[#ffb703] text-[#0d1b2a] rotate-180"
                            : "border-[#0d1b2a]/20 text-[#0d1b2a] group-hover:border-[#ffb703]"
                        }`}
                      >
                        {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                      </span>
                    </button>
                    <div
                      className={`overflow-hidden transition-all duration-300 ease-out ${
                        isOpen ? "max-h-60 opacity-100 pb-6" : "max-h-0 opacity-0"
                      }`}
                    >
                      <p className="text-sm sm:text-base text-[#0d1b2a]/70 leading-relaxed pr-12">
                        {it.a}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
